<script setup lang="ts">
  import { computed } from "vue";
  import { Badge, Text } from "@ui-kit";
  import { ProductMiniCard } from "@src/components";
  import { useStateActionList, type Good } from "./state";
  import { getOrderReason } from "@src/dictionary";

  const {
    image_url = "",
    title = "",
    article = "",
    color = "",
    goodList = [],
  } = defineProps<{
    image_url: string;
    title: string;
    article: string;
    color: string;
    goodList: Good[];
  }>();

  const actionListState = useStateActionList();

  const preparedGoodList = computed(() => {
    const other = [];
    const canceled = [];

    for (const good of goodList) {
      const actions = actionListState.getActionsGroupedByStatus(good.item.item_id);

      actions.forEach((action) => {
        const item = {
          id: good.item.item_id,
          size: good.item.size,
          count: action.count,
          reason: action.reason,
        };

        if (action.reason) {
          canceled.push(item);
        } else {
          other.push(item);
        }
      });
    }

    return { canceled, other };
  });
</script>

<template>
  <div class="order-card-item-completed">
    <ProductMiniCard :image="image_url" :name="title" :article="article" :color="color" />
    <hr class="divider" />
    <div class="size-list-container">
      <Text font="body-regular-14" color="success">{{ $t("Собрано:") }}</Text>
      <div class="size-list">
        <template v-for="item in preparedGoodList.other" :key="item.item_id">
          <Badge
            size="s"
            :label="`${item.size.toUpperCase() ?? '-'} - ${item.count + ' ' + $t('шт') + '.'}`"
            variant="primary"
          />
        </template>
      </div>
    </div>
    <div class="size-list-container">
      <Text font="body-regular-14" color="error">{{ $t("Отменено:") }}</Text>
      <div class="size-list">
        <template v-for="item in preparedGoodList.canceled" :key="item.item_id">
          <Badge
            size="s"
            :label="`${item.size.toUpperCase() ?? '-'} - ${item.count + ' ' + $t('шт') + ', ' + getOrderReason(item.reason).toLowerCase()}`"
            variant="primary"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<style scoped>
  .order-card-item-completed {
    display: flex;
    flex-direction: column;
    gap: 12px;
    padding: 12px;
    border-radius: 16px;
    background-color: var(--sf-base-background-white);

    .divider {
      height: 1px;
      width: 100%;
      background-color: var(--sf-base-border-primary);
    }

    .size-list-container {
      display: flex;
      flex-direction: column;
      gap: 8px;
    }

    .size-list {
      display: flex;
      gap: 8px;
      flex-wrap: wrap;
    }
  }
</style>
